import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// tailwind-merge only dedupes classes it knows about. The project's custom
// `typo-*` utilities (global.css) are mutually exclusive — without this group
// `cn('typo-base', 'typo-lg')` keeps BOTH and the global.css declaration
// order silently wins over the caller's intent (caught by devtools-verify on
// the wizard's proctoring checkbox label, stage 5).
const twMerge = extendTailwindMerge<'typo'>({
  extend: {
    classGroups: {
      typo: [
        {
          typo: [
            'biggest',
            'heading',
            'subheading',
            'lg-strong',
            'lg',
            'base-selected',
            'base',
            'tag',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
